// extracted by mini-css-extract-plugin
export default {"v-fog":"var(--fog)","banner":"cta_banner__banner__P__Wm","imageLink":"cta_banner__imageLink__Nc8yA","image":"cta_banner__image___0qta"};